// lazy load
(function () {
    var addImageIntersectionSetSrc, addImageSetSrc, intersectionObserverAllowed, io, lazyLoad, retinaReadyClass;

    intersectionObserverAllowed = Boolean(window.IntersectionObserver);

    if (intersectionObserverAllowed) {
        io = new IntersectionObserver(function (entries) {
            return entries.forEach(function (entry) {
                var $img;
                if (entry.intersectionRatio > 0) {
                    $img = $(entry.target);
                    return $img.one('load', function () {
                        $img.addClass('b-loaded');
                        return io.unobserve(entry.target);
                    }).attr('src', $img.data('src-to-set'));
                }
            });
        }, {
            threshold: 0.2
        });
    }

    addImageSetSrc = function () {
        return function (i, img) {
            var src;
            src = img.dataset.src;
            img.src = src;
            if (img.complete) {
                $(img).trigger('load');
            }
        };
    };

    addImageIntersectionSetSrc = function () {
        return function (i, img) {
            var src;
            src = img.dataset.src;
            $(img).data('src-to-set', src);
            io.observe(img);
        };
    };

    lazyLoad = function ($el) {
        var $elements, selector;
        selector = 'img.js-lazy-load';
        if (!intersectionObserverAllowed) {
            selector += ', img.js-lazy-load-intersection';
        }
        if ($el) {
            $elements = $el.find(selector);
        } else {
            $elements = $(selector);
        }
        $elements.on('load', function () {
            $(this).addClass('b-loaded');
        });
        $elements.each(addImageSetSrc());
        if (intersectionObserverAllowed) {
            selector = 'img.js-lazy-load-intersection:not(".b-loaded")';
            if ($el) {
                $elements = $el.find(selector);
            } else {
                $elements = $(selector);
            }
            $elements.each(addImageIntersectionSetSrc());
        }
    };

    this.lazyLoad = lazyLoad;

})();

var loaded = {};

var loadCSS = function (url, cb) {
    var loadFunction;
    var css = void 0;
    loadFunction = function () {
        if (loaded[url]) {
            return;
        }
        loaded[url] = true;
        return cb && cb();
    };
    if (document.getElementById(url)) {
        css = document.getElementById(url);
        css.onload = loadFunction;
        css.onreadystatechange = loadFunction;
        if (loaded[url]) {
            return cb && cb();
        }
        return;
    }
    css = document.createElement('link');
    css.setAttribute('href', url);
    css.setAttribute('media', 'all');
    css.setAttribute('rel', 'stylesheet');
    css.setAttribute('id', url);
    css.onload = loadFunction;
    document.getElementsByTagName('head')[0].appendChild(css);
};


var initJS = function () {
    window.lazyLoad();
    dataLayer.push({
        'page': location.pathname + location.search
    });

    // menu
    $('#js-menu-close').click(function () {
        $('#js-menu a').each(function (i) {
            var $el = $(this);
            setTimeout(function () {
                $el.removeClass('b-animate-in-position');
            }, i * 100);
            setTimeout(function () {
                $el.removeClass('b-animate-in-opacity');
            }, i * 100 + 100);
        });

        $('body').removeClass('b-menu-fully-loaded');

        setTimeout(function () {
            $('body').removeClass('b-menu-active');

            setTimeout(function () {
                $('body').removeClass('b-start-animate')
            }, 500);

            setTimeout(function () {
                $('body').removeClass('b-menu-bg-active')
            }, 800)
        }, 400);
    });

    $('#js-menu-open').on('click', function () {
        $('body').addClass('b-start-animate b-menu-bg-active b-menu-active');
        setTimeout(function () {
            $('#js-menu a').each(function (i) {
                var $el = $(this);
                setTimeout(function () {
                    $el.addClass('b-animate-in-position');
                }, i * 100);
                setTimeout(function () {
                    $el.addClass('b-animate-in-opacity');
                }, i * 100 + 100);
            });
        }, 260);

        setTimeout(
            function () {
                $('body').addClass('b-menu-fully-loaded');
            }, 1400
        );
    });

    $('#js-menu').css({
        transition: 'transform .33s ease-out', // wtf fix
        display:    'block',
        top:        0,
        right:      0,
        zIndex:     2
    });

    //точки слайдера

    $('.js-slider-point').on('mouseenter', function () {
        $('.js-slider-point').removeClass('b-active');
        $(this).addClass('b-active');
    }).on('mouseleave', function () {
        $('.js-slider-point').removeClass('b-active');
    });

    // slider
    var lazyLoadActiveElements = function (e) {
        var $elements;
        $elements = $(e.currentTarget).find('.owl-item.active');
        $elements.find('.js-lazy-load-manual').removeClass('js-lazy-load-manual').addClass('js-lazy-load');
        return window.lazyLoad($elements);
    };

    var $slider = $('.index-slider');

    if ($slider.length > 0) {
        setTimeout(function () {
            $slider.on('changed.owl.carousel', function (e) {
                return setTimeout(lazyLoadActiveElements, 0, e);
            });
            $slider.on('initialized.owl.carousel', function (e) {
                return setTimeout(lazyLoadActiveElements, 0, e);
            });

            $slider.addClass('owl-carousel');
            $('.js-slider-point').on('mouseenter', function () {
                $slider.trigger('stop.owl.autoplay');
            }).on('mouseleave', function () {
                $slider.trigger('play.owl.autoplay', [0, 7000]);
            });

            $slider.owlCarousel({
                animateOut:      'fadeOut',
                animateIn:       'fadeIn',
                autoplay:        true,
                loop:            true,
                items:           1,
                dots:            false,
                nav:             false,
                mouseDrag:       false,
                touchDrag:       false,
                pullDrag:        false,
                autoplayTimeout: 7000
            })
        }, 1000);
    }

    // collection
    var $selectors = $('.js-collection-selector');
    var $collectionImages = $('.js-collection-images');
    var $collectionInfo = $('.js-collection-info');
    var $mainImages = $('.js-desktop-collection-images');
    var currentCollection = $selectors.first().data('id');
    var $sliders = $('<div/>');

    var turnOnSlider = function ($_slider) {
        if (!$_slider || $_slider.hasClass('owl-loaded')) {
            return;
        }
        $_slider.on('changed.owl.carousel', function (e) {
            return setTimeout(lazyLoadActiveElements, 0, e);
        });
        $_slider.on('initialized.owl.carousel', function (e) {
            return setTimeout(lazyLoadActiveElements, 0, e);
        });
        var margin = 10;
        $_slider.addClass('owl-carousel').owlCarousel({
            items:  2,
            loop:   false,
            margin: margin,
            dots:   false,
            nav:    false
        });
    };

    var turnOnMainImage = function ($_image) {
        $_image.find('img').removeClass('js-lazy-load-manual').addClass('js-lazy-load');
        lazyLoad($_image);
    };

    $selectors.on('click', function () {
        var $selector = $(this);
        currentCollection = $selector.data('id');
        $selectors.removeClass('b-active');
        var filter = '[data-id="' + currentCollection + '"]';
        var $_slider = $sliders.filter(filter);
        var $_images = $collectionImages.filter(filter);
        var $_mainImage = $mainImages.filter(filter);
        var $_info = $collectionInfo.filter(filter);

        $collectionImages.hide();
        $collectionInfo.hide();
        $_images.show();
        $_info.show();
        $_slider.show();
        $selector.addClass('b-active');
        turnOnSlider($_slider);
        turnOnMainImage($_mainImage);
        lazyLoadActiveElements($_images);
        lazyLoadActiveElements($_info);
    });

    if (matchMedia('(max-width: 767px)').matches) {
        $sliders = $('.js-mobile-collection-slider');
        $mainImages = $('<div/>');

        var $firstCollectionSlider = $sliders.first();

        if ($firstCollectionSlider) {
            $firstCollectionSlider.children('img:eq(0), img:eq(1)').removeClass('js-lazy-load-manual').addClass('js-lazy-load');

            lazyLoad($firstCollectionSlider);
            turnOnSlider($firstCollectionSlider);

        }
    } else {
        turnOnMainImage($mainImages.filter('[data-id="' + currentCollection + '"]'));
    }

    var $productImage = $('#js-product-image');

    if ($productImage.length) {
        var initialized = false;
        $('body').on('mouseover touchstart', function () {
            if (initialized) {
                return
            }
            initialized = true;
            $productImage.zoom({
                url: $productImage.data('full-image')
            });
        })
    }
};

InstantClick.on('change', initJS);
InstantClick.init();
window.setCookie = function (name, value, domain, days) {
    var date, expires;
    if (domain == null) {
        domain = '';
    }
    expires = '';
    if (days) {
        date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        date = date.toUTCString();
        expires = "; expires=" + date;
    }
    if (domain) {
        domain = '; domain=' + domain;
    }
    return document.cookie = name + "=" + value + expires + "; path=/" + domain;
};
loadCSS(OKAMI.links.static_url + 'css/styles.css?' + window.OKAMI.css_hash_value, function () {
    window.setCookie(
        window.OKAMI.critical_css_invalidation_cookie_name,
        window.OKAMI.critical_css_invalidation_cookie_value
    );
    $(initJS);
});